<template>
  <div class="prize-page">
    <header class="prize-header">
      <img class="prize-title" :src="titleImage" :alt="$t(activePeriod === 'week' ? 'PrizeWeeklyTitle' : 'PrizeMonthlyTitle')">
    </header>

    <main class="prize-content">
      <nav class="prize-tabs" :aria-label="$t('HomeNavPrizes')">
        <img class="prize-tabs-bg" src="../../static/images/prize/week_month_title_bg.png" alt="">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          type="button"
          :class="{ active: activePeriod === tab.value }"
          @click="activePeriod = tab.value"
        >
          <img v-if="activePeriod === tab.value" src="../../static/images/prize/week_month_active_title_bg.png" alt="">
          <span>{{ tab.label }}</span>
        </button>
      </nav>

      <section v-if="activePeriod === 'week'" class="prize-grid" :aria-label="$t('PrizeWeeklyTitle')">
        <article
          v-for="item in weeklyPrizes"
          :key="item.key"
          class="prize-item"
          :class="{ 'is-featured': item.featured }"
        >
          <div class="prize-rank-label"><span>{{ $t(item.label) }}</span></div>
          <div class="prize-art-wrap">
            <img :src="item.image" :alt="$t(item.label)">
          </div>
        </article>
      </section>

      <section v-else class="monthly-prize-stage" :aria-label="$t('PrizeMonthlyTitle')">
        <article class="monthly-prize monthly-prize-first">
          <div class="prize-rank-label"><span>{{ $t('PrizeFirstWinner') }}</span></div>
          <img src="../../static/images/prize/month_1st_prize.png" :alt="$t('PrizeFirstWinner')">
        </article>
        <article class="monthly-prize monthly-prize-second">
          <div class="prize-rank-label"><span>{{ $t('PrizeSecondWinner') }}</span></div>
          <img src="../../static/images/prize/month_2nd_prize.png" :alt="$t('PrizeSecondWinner')">
        </article>
        <article class="monthly-prize monthly-prize-third">
          <div class="prize-rank-label"><span>{{ $t('PrizeThirdWinner') }}</span></div>
          <img src="../../static/images/prize/month_3rd_prize.png" :alt="$t('PrizeThirdWinner')">
        </article>
        <article class="monthly-prize monthly-prize-fourth-tenth">
          <div class="prize-rank-label"><span>{{ $t('PrizeFourthToTenthWinners') }}</span></div>
          <img src="../../static/images/prize/month_4th-10th_prize.png" :alt="$t('PrizeFourthToTenthWinners')">
        </article>
        <article class="monthly-prize monthly-prize-eleventh-twentieth">
          <div class="prize-rank-label"><span>{{ $t('PrizeEleventhToTwentiethWinners') }}</span></div>
          <img src="../../static/images/prize/month_11th-20th_prize.png" :alt="$t('PrizeEleventhToTwentiethWinners')">
        </article>
      </section>
    </main>

    <nav class="prize-bottom-nav" aria-label="Primary">
      <img class="prize-bottom-nav-bg" src="../../static/images/home/nevigator_bg.png" alt="">
      <button type="button" @click="go('rank')">
        <img src="../../static/images/home/rank.png" alt="">
        <span>{{ $t('Ranking') }}</span>
      </button>
      <button type="button" @click="go('')">
        <img src="../../static/images/home/home_act.png" alt="">
        <span>{{ $t('LiveQuizHome') }}</span>
      </button>
      <button class="is-current" type="button" aria-current="page">
        <img class="prize-bottom-nav-active" src="../../static/images/home/nevigator_menu_act.png" alt="">
        <img src="../../static/images/home/prize_act.png" alt="">
        <span>{{ $t('HomeNavPrizes') }}</span>
      </button>
    </nav>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activePeriod: this.$route.query.period === 'month' ? 'month' : 'week',
      weeklyPrizes: [
        { key: 'week-first', label: 'PrizeFirstWinner', image: '../../static/images/prize/week_1st_prize.png' },
        { key: 'week-second', label: 'PrizeSecondWinner', image: '../../static/images/prize/week_2nd_prize.png' },
        { key: 'week-third-tenth', label: 'PrizeThirdToTenthWinners', image: '../../static/images/prize/week_3rd-10th_prize.png' },
        { key: 'week-eleventh-thirtieth', label: 'PrizeEleventhToThirtiethWinners', image: '../../static/images/prize/week_11th-30th_prize.png' }
      ]
    }
  },
  computed: {
    tabs () {
      return [
        { value: 'week', label: this.$t('Weekly') },
        { value: 'month', label: this.$t('Monthly') }
      ]
    },
    titleImage () {
      return this.activePeriod === 'week'
        ? '../../static/images/prize/weekly_prizes_title.png'
        : '../../static/images/prize/monthly_prizes_title.png'
    }
  },
  methods: {
    go (path) {
      this.$router.push({ path: '/' + path })
    }
  }
}
</script>

<style scoped>
.prize-page {
  box-sizing: border-box;
  height: 100vh;
  min-height: 100vh;
  padding: 48px 28px 260px;
  overflow: hidden;
  color: #fff;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, Atom-sans, sans-serif;
}
.prize-header { position: relative; display: flex; min-height: 156px; align-items: center; justify-content: center; }
.prize-title { display: block; width: min(110vw, 690px); height: auto; }
.prize-content { width: min(100%, 620px); margin: 22px auto 0; }
.prize-tabs { position: relative; display: flex; width: min(82%, 440px); height: 82px; margin: 0 auto 58px; align-items: center; }
.prize-tabs-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: fill; }
.prize-tabs button { position: relative; z-index: 1; display: flex; flex: 1 1 50%; height: 100%; align-items: center; justify-content: center; padding: 0; overflow: hidden; border: 0; background: transparent; color: rgba(255,255,255,.65); font-size: 25px; font-style: italic; font-weight: 800; }
.prize-tabs button img { position: absolute; inset: 2px 0; width: 100%; height: calc(100% - 4px); object-fit: fill; }
.prize-tabs button span { position: relative; z-index: 1; }
.prize-tabs button.active { color: #fff; }
.prize-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 48px 22px; align-items: end; }
.prize-item { min-width: 0; text-align: center; }
.prize-art-wrap { position: relative; }
.prize-grid .prize-art-wrap > img { display: block; width: 132%; max-width: 360px; height: auto; margin: -20px auto 0; transform: translateX(-12%) translateY(-100px); }
.prize-item:nth-child(n + 3) { margin-top: -28px; }
.prize-rank-label { position: relative; z-index: 1; display: inline-flex; min-height: 50px; max-width: 100%; align-items: center; justify-content: center; padding: 0 19px; border: 1px solid #f1298e; border-radius: 28px; background-color: rgba(101, 17, 79, .78); box-shadow: inset 0 0 16px rgba(250, 32, 142, .42); }
.prize-rank-label::after { position: absolute; bottom: -9px; left: 50%; width: 16px; height: 16px; content: ''; border-right: 1px solid #f1298e; border-bottom: 1px solid #f1298e; background-color: rgba(101, 17, 79, .9); transform: translateX(-50%) rotate(45deg); }
.prize-rank-label span { color: #fff; font-size: 20px; font-weight: 700; line-height: 1.15; }
.monthly-prize-stage { position: relative; height: calc(100vh - 390px); min-height: 520px; }
.monthly-prize { position: absolute; z-index: 0; text-align: center; }
.monthly-prize > img { position: absolute; z-index: 0; left: 50%; display: block; height: auto; transform: translateX(-50%); }
.monthly-prize .prize-rank-label { z-index: 2; }
.monthly-prize-first { top: 0; left: 0; width: 100%; }
.monthly-prize-first > img { top: -260px; width: min(116%, 610px); }
.monthly-prize-second,
.monthly-prize-third { top: 18vh; width: 50%; }
.monthly-prize-second { left: 0; }
.monthly-prize-third { right: 0; }
.monthly-prize-second > img,
.monthly-prize-third > img { top: -95px; width: 108%; }
.monthly-prize-fourth-tenth,
.monthly-prize-eleventh-twentieth { top: 37vh; width: 50%; }
.monthly-prize-fourth-tenth { left: 0; }
.monthly-prize-eleventh-twentieth { right: 0; }
.monthly-prize-fourth-tenth > img,
.monthly-prize-eleventh-twentieth > img { top: -40px; width: 90%; }
.prize-bottom-nav { position: fixed; z-index: 50; bottom: 16px; left: 50%; width: calc(100% - 56px); transform: translateX(-50%); }
.prize-bottom-nav-bg { display: block; width: 100%; }
.prize-bottom-nav button { position: absolute; top: 8%; bottom: 10%; display: flex; width: 33.33%; align-items: center; justify-content: flex-end; flex-direction: column; gap: 1px; padding: 0; border: 0; background: transparent; color: rgba(255,255,255,.62); font-size: clamp(13px, 4.4vw, 28px); font-weight: 800; line-height: 1; }
.prize-bottom-nav button:nth-of-type(2) { left: 33.33%; }
.prize-bottom-nav button:nth-of-type(3) { right: 0; }
.prize-bottom-nav button > img:not(.prize-bottom-nav-active) { position: relative; z-index: 1; width: 74px; height: 74px; object-fit: contain; }
.prize-bottom-nav button.is-current { color: #fff; }
.prize-bottom-nav-active { position: absolute; z-index: 0; top: -4px; width: 82% !important; height: auto !important; max-height: none !important; object-fit: contain; }
.prize-bottom-nav .is-current > img:not(.prize-bottom-nav-active) { width: 128px; height: 128px; margin-top: -74px; transform: translateY(-30px); }
.prize-bottom-nav .is-current span { position: relative; z-index: 1; }
@media (max-width: 420px) {
  .prize-page { padding: 45px 18px 222px; }
  .prize-header { min-height: 150px; }
  .prize-title { width: 110vw; }
  .prize-content { margin-top: 16px; }
  .prize-tabs { width: 82%; height: 68px; margin-bottom: 46px; }
  .prize-tabs button { font-size: 21px; }
  .prize-grid { gap: 36px 14px; }
  .prize-grid .prize-art-wrap > img { max-width: none; transform: translateX(-12%) translateY(-100px); }
  .prize-item:nth-child(n + 3) { margin-top: -28px; }
  .monthly-prize-stage { height: calc(100vh - 330px); min-height: 500px; }
  .monthly-prize-first > img { width: min(116%, 560px); }
  .prize-rank-label { min-height: 44px; padding: 0 12px; }
  .prize-rank-label span { font-size: 17px; }
  .prize-bottom-nav { bottom: 9px; width: calc(100% - 36px); }
  .prize-bottom-nav button > img:not(.prize-bottom-nav-active) { width: 60px; height: 60px; }
  .prize-bottom-nav .is-current > img:not(.prize-bottom-nav-active) { width: 106px; height: 106px; margin-top: -60px; transform: translateY(-26px); }
}
</style>



// WEBPACK FOOTER //
// src/page/prize.vue